/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CaseEntityDto } from './CaseEntityDto';
import {
    CaseEntityDtoFromJSON,
    CaseEntityDtoFromJSONTyped,
    CaseEntityDtoToJSON,
    CaseEntityDtoToJSONTyped,
} from './CaseEntityDto';
import type { CaseSourceDto } from './CaseSourceDto';
import {
    CaseSourceDtoFromJSON,
    CaseSourceDtoFromJSONTyped,
    CaseSourceDtoToJSON,
    CaseSourceDtoToJSONTyped,
} from './CaseSourceDto';
import type { CaseFeedbackDto } from './CaseFeedbackDto';
import {
    CaseFeedbackDtoFromJSON,
    CaseFeedbackDtoFromJSONTyped,
    CaseFeedbackDtoToJSON,
    CaseFeedbackDtoToJSONTyped,
} from './CaseFeedbackDto';
import type { CaseTypeDto } from './CaseTypeDto';
import {
    CaseTypeDtoFromJSON,
    CaseTypeDtoFromJSONTyped,
    CaseTypeDtoToJSON,
    CaseTypeDtoToJSONTyped,
} from './CaseTypeDto';
import type { EventDto } from './EventDto';
import {
    EventDtoFromJSON,
    EventDtoFromJSONTyped,
    EventDtoToJSON,
    EventDtoToJSONTyped,
} from './EventDto';
import type { CloseReasonDto } from './CloseReasonDto';
import {
    CloseReasonDtoFromJSON,
    CloseReasonDtoFromJSONTyped,
    CloseReasonDtoToJSON,
    CloseReasonDtoToJSONTyped,
} from './CloseReasonDto';

/**
 * Security case data transfer object with audit information
 * @export
 * @interface CaseDto
 */
export interface CaseDto {
    /**
     * 
     * @type {string}
     * @memberof CaseDto
     */
    id?: string;
    /**
     * 
     * @type {CaseTypeDto}
     * @memberof CaseDto
     */
    caseType?: CaseTypeDto;
    /**
     * 
     * @type {string}
     * @memberof CaseDto
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseDto
     */
    severity?: CaseDtoSeverityEnum;
    /**
     * 
     * @type {string}
     * @memberof CaseDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseDto
     */
    status?: CaseDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof CaseDto
     */
    owner?: string;
    /**
     * When this record was created (UTC)
     * @type {Date}
     * @memberof CaseDto
     */
    createdAt?: Date;
    /**
     * When this record was last updated (UTC)
     * @type {Date}
     * @memberof CaseDto
     */
    updatedAt?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof CaseDto
     */
    escalated?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof CaseDto
     */
    escalatedTime?: Date;
    /**
     * 
     * @type {number}
     * @memberof CaseDto
     */
    escalationCount?: number;
    /**
     * 
     * @type {Array<EventDto>}
     * @memberof CaseDto
     */
    events?: Array<EventDto>;
    /**
     * 
     * @type {string}
     * @memberof CaseDto
     */
    summary?: string;
    /**
     * 
     * @type {Array<CaseEntityDto>}
     * @memberof CaseDto
     */
    entities?: Array<CaseEntityDto>;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof CaseDto
     */
    customFields?: { [key: string]: any; };
    /**
     * 
     * @type {CloseReasonDto}
     * @memberof CaseDto
     */
    closeReason?: CloseReasonDto;
    /**
     * 
     * @type {string}
     * @memberof CaseDto
     */
    closeRationale?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseDto
     */
    tenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseDto
     */
    tenantName?: string;
    /**
     * 
     * @type {Array<CaseSourceDto>}
     * @memberof CaseDto
     */
    sources?: Array<CaseSourceDto>;
    /**
     * 
     * @type {string}
     * @memberof CaseDto
     */
    correlationGroup?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof CaseDto
     */
    correlationMetadata?: { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof CaseDto
     */
    metadata?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof CaseDto
     */
    sourceId?: string;
    /**
     * 
     * @type {Array<CaseFeedbackDto>}
     * @memberof CaseDto
     */
    feedback?: Array<CaseFeedbackDto>;
    /**
     * 
     * @type {number}
     * @memberof CaseDto
     */
    notifySLATimer?: number;
    /**
     * 
     * @type {number}
     * @memberof CaseDto
     */
    detectionSLATimer?: number;
    /**
     * 
     * @type {number}
     * @memberof CaseDto
     */
    assignmentSLATimer?: number;
    /**
     * 
     * @type {number}
     * @memberof CaseDto
     */
    remediationSLATimer?: number;
    /**
     * 
     * @type {number}
     * @memberof CaseDto
     */
    durationSLATimer?: number;
    /**
     * User ID who created this record
     * @type {string}
     * @memberof CaseDto
     */
    createdByUserId?: string;
    /**
     * Username who created this record
     * @type {string}
     * @memberof CaseDto
     */
    createdByUsername?: string;
    /**
     * User ID who last updated this record
     * @type {string}
     * @memberof CaseDto
     */
    updatedByUserId?: string;
    /**
     * Username who last updated this record
     * @type {string}
     * @memberof CaseDto
     */
    updatedByUsername?: string;
}


/**
 * @export
 */
export const CaseDtoSeverityEnum = {
    Critical: 'CRITICAL',
    High: 'HIGH',
    Medium: 'MEDIUM',
    Low: 'LOW',
    Info: 'INFO'
} as const;
export type CaseDtoSeverityEnum = typeof CaseDtoSeverityEnum[keyof typeof CaseDtoSeverityEnum];

/**
 * @export
 */
export const CaseDtoStatusEnum = {
    Open: 'OPEN',
    InProgress: 'IN_PROGRESS',
    Escalated: 'ESCALATED',
    Resolved: 'RESOLVED'
} as const;
export type CaseDtoStatusEnum = typeof CaseDtoStatusEnum[keyof typeof CaseDtoStatusEnum];


/**
 * Check if a given object implements the CaseDto interface.
 */
export function instanceOfCaseDto(value: object): value is CaseDto {
    return true;
}

export function CaseDtoFromJSON(json: any): CaseDto {
    return CaseDtoFromJSONTyped(json, false);
}

export function CaseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CaseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'caseType': json['caseType'] == null ? undefined : CaseTypeDtoFromJSON(json['caseType']),
        'type': json['type'] == null ? undefined : json['type'],
        'severity': json['severity'] == null ? undefined : json['severity'],
        'name': json['name'] == null ? undefined : json['name'],
        'status': json['status'] == null ? undefined : json['status'],
        'owner': json['owner'] == null ? undefined : json['owner'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'escalated': json['escalated'] == null ? undefined : json['escalated'],
        'escalatedTime': json['escalatedTime'] == null ? undefined : (new Date(json['escalatedTime'])),
        'escalationCount': json['escalationCount'] == null ? undefined : json['escalationCount'],
        'events': json['events'] == null ? undefined : ((json['events'] as Array<any>).map(EventDtoFromJSON)),
        'summary': json['summary'] == null ? undefined : json['summary'],
        'entities': json['entities'] == null ? undefined : ((json['entities'] as Array<any>).map(CaseEntityDtoFromJSON)),
        'customFields': json['customFields'] == null ? undefined : json['customFields'],
        'closeReason': json['closeReason'] == null ? undefined : CloseReasonDtoFromJSON(json['closeReason']),
        'closeRationale': json['closeRationale'] == null ? undefined : json['closeRationale'],
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'tenantName': json['tenantName'] == null ? undefined : json['tenantName'],
        'sources': json['sources'] == null ? undefined : ((json['sources'] as Array<any>).map(CaseSourceDtoFromJSON)),
        'correlationGroup': json['correlationGroup'] == null ? undefined : json['correlationGroup'],
        'correlationMetadata': json['correlationMetadata'] == null ? undefined : json['correlationMetadata'],
        'metadata': json['metadata'] == null ? undefined : json['metadata'],
        'sourceId': json['sourceId'] == null ? undefined : json['sourceId'],
        'feedback': json['feedback'] == null ? undefined : ((json['feedback'] as Array<any>).map(CaseFeedbackDtoFromJSON)),
        'notifySLATimer': json['notifySLATimer'] == null ? undefined : json['notifySLATimer'],
        'detectionSLATimer': json['detectionSLATimer'] == null ? undefined : json['detectionSLATimer'],
        'assignmentSLATimer': json['assignmentSLATimer'] == null ? undefined : json['assignmentSLATimer'],
        'remediationSLATimer': json['remediationSLATimer'] == null ? undefined : json['remediationSLATimer'],
        'durationSLATimer': json['durationSLATimer'] == null ? undefined : json['durationSLATimer'],
        'createdByUserId': json['createdByUserId'] == null ? undefined : json['createdByUserId'],
        'createdByUsername': json['createdByUsername'] == null ? undefined : json['createdByUsername'],
        'updatedByUserId': json['updatedByUserId'] == null ? undefined : json['updatedByUserId'],
        'updatedByUsername': json['updatedByUsername'] == null ? undefined : json['updatedByUsername'],
    };
}

export function CaseDtoToJSON(json: any): CaseDto {
    return CaseDtoToJSONTyped(json, false);
}

export function CaseDtoToJSONTyped(value?: CaseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'caseType': CaseTypeDtoToJSON(value['caseType']),
        'type': value['type'],
        'severity': value['severity'],
        'name': value['name'],
        'status': value['status'],
        'owner': value['owner'],
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt']).toISOString()),
        'escalated': value['escalated'],
        'escalatedTime': value['escalatedTime'] == null ? undefined : ((value['escalatedTime']).toISOString()),
        'escalationCount': value['escalationCount'],
        'events': value['events'] == null ? undefined : ((value['events'] as Array<any>).map(EventDtoToJSON)),
        'summary': value['summary'],
        'entities': value['entities'] == null ? undefined : ((value['entities'] as Array<any>).map(CaseEntityDtoToJSON)),
        'customFields': value['customFields'],
        'closeReason': CloseReasonDtoToJSON(value['closeReason']),
        'closeRationale': value['closeRationale'],
        'tenantId': value['tenantId'],
        'tenantName': value['tenantName'],
        'sources': value['sources'] == null ? undefined : ((value['sources'] as Array<any>).map(CaseSourceDtoToJSON)),
        'correlationGroup': value['correlationGroup'],
        'correlationMetadata': value['correlationMetadata'],
        'metadata': value['metadata'],
        'sourceId': value['sourceId'],
        'feedback': value['feedback'] == null ? undefined : ((value['feedback'] as Array<any>).map(CaseFeedbackDtoToJSON)),
        'notifySLATimer': value['notifySLATimer'],
        'detectionSLATimer': value['detectionSLATimer'],
        'assignmentSLATimer': value['assignmentSLATimer'],
        'remediationSLATimer': value['remediationSLATimer'],
        'durationSLATimer': value['durationSLATimer'],
        'createdByUserId': value['createdByUserId'],
        'createdByUsername': value['createdByUsername'],
        'updatedByUserId': value['updatedByUserId'],
        'updatedByUsername': value['updatedByUsername'],
    };
}

